import React, { useRef } from "react";
import styled from "styled-components";

import ReactPlayer from "react-player";

import { ButtonIcon, Button } from "./CardButtonStyle";

import { machineConfig, annotationConfig } from "../../data/machine.js";
import { colorPalette } from "../../Config/colorConfig.js";

import {
  cardListIcon,
  videoIcon,
  moreInfoIcon,
  onlineDemoIcon,
  questionIcon,
  locationIcon,
} from "../../Config/cardConfig.js";

//RWD: 1300 & 1000
const IntroAndImgWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  @media (max-width: 1000px) {
    flex-direction: column-reverse;
    margin-bottom: 0rem;
  }
`;

const TextIframe = styled.iframe`
  width: 45%;
  height: 450px;
  border: none;
  @media (max-width: 1000px) {
    width: 90%;
    height: 450px;
  }
  @media (max-width: 768px) {
    height: 600px;
  }
`;

const MachineIframe = styled.iframe`
  width: 45%;
  height: 450px;
  border: none;
  @media (max-width: 1000px) {
    width: 90%;
    height: 400px;
  }
  @media (max-width: 768px) {
    height: 350px;
  }
`;

const Img = styled.img`
  display: flex;
  width: 45%;
  height: auto;
  @media (max-width: 1000px) {
    margin-bottom: 15px;
    width: 60%;
  }
`;

const IntroductionWrapper = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 3rem;
  @media (max-width: 1300px) {
    padding-right: 1rem;
  }
  @media (max-width: 1000px) {
    width: 60%;
    padding-right: 0rem;
  }
`;

//for subtitle and ar button
const SubTitleAndBtnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const SubTitle = styled.div`
  display: flex;
  color: ${colorPalette.myBlue};
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  @media (max-width: 1000px) {
    font-size: 1.2rem;
  }
`;

const Introduction = styled.ul`
  color: #000;
  list-style-image: url(${cardListIcon});
  font-size: 1rem;
  padding: 0px 0px 4rem 1rem;
  & > li {
    margin-bottom: 1rem;
  }
`;

const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  @media (max-width: 1300px) {
    flex-direction: column;
  }
  justify-content: center;
  align-items: center;
`;

const SpecificationTable = styled.table`
  position: relative;
  width: 80%;
  max-width: 800px;
  border-collapse: collapse;
  border-top: 1px solid ${colorPalette.myGrey};
  //text-align: center;
  color: #000;
  margin-top: 1rem;
  font-weight: 400;
  & > tr {
    height: 2rem;
    text-align: left;
    & > td {
      width: 50%;
    }
  }
  > tr:nth-child(even) {
    background-color: ${colorPalette.myGrey};
    border: none;
  }
`;

const Annotation = styled.div`
  position: relative;
  max-width: 800px;
  width: 80%;
  font-size: 0.8rem;
  font-weight: 200;
  margin-bottom: 40px;
`;

const MachineCard = (props) => {
  const { contentRef, cardContent, onPlay, setOnPlay, langCh } = props;

  const playerRef = useRef(null);

  return (
    <>
      {!machineConfig[cardContent][langCh ? "ch" : "en"].ar && (
        <IntroAndImgWrapper>
          <IntroductionWrapper>
            <SubTitleAndBtnWrapper>
              <SubTitle>
                {machineConfig[cardContent][langCh ? "ch" : "en"].subtitle}
              </SubTitle>
            </SubTitleAndBtnWrapper>
            <Introduction>
              {machineConfig[cardContent][
                langCh ? "ch" : "en"
              ].introduction.map((data, i) => (
                <li key={i} style={{ textAlign: langCh ? "justify" : "left" }}>
                  {data}
                </li>
              ))}
            </Introduction>
          </IntroductionWrapper>
          <Img
            src={machineConfig[cardContent][langCh ? "ch" : "en"].machineImg}
          />
        </IntroAndImgWrapper>
      )}

      {machineConfig[cardContent][langCh ? "ch" : "en"].ar && (
        <IntroAndImgWrapper>
          <TextIframe
            src={machineConfig[cardContent][langCh ? "ch" : "en"].ar[0]}
            scrolling="no"
          />
          <MachineIframe
            src={machineConfig[cardContent][langCh ? "ch" : "en"].ar[1]}
            scrolling="no"
          />
        </IntroAndImgWrapper>
      )}

      {machineConfig[cardContent][langCh ? "ch" : "en"].videoUrl && (
        <div
          style={{
            position: onPlay ? "absolute" : "relative",
            marginBottom: "10px",
            zIndex: "200",
            marginTop: "15px",
          }}
        >
          <ReactPlayer
            ref={playerRef}
            url={machineConfig[cardContent][langCh ? "ch" : "en"].videoUrl}
            width={onPlay ? contentRef.current.clientWidth : "30vw"}
            height={onPlay ? contentRef.current.clientHeight : "17vw"}
            style={{ minWidth: "250px", minHeight: "140px" }}
            light={false}
            onPlay={() => {
              //console.log('onPlay');
              //console.log(playerRef.current.props.width)
              //console.log(contentRef)
              //console.log(playerRef)
              setOnPlay(true);
            }}
            onPause={() => {
              //console.log('pause')
              setOnPlay(false);
            }}
          />
        </div>
      )}
      <ButtonWrapper>
        {machineConfig[cardContent][langCh ? "ch" : "en"].buttonVideoUrl && (
          <Button
            onClick={(e) => {
              e.preventDefault();
              window.open(
                machineConfig[cardContent][langCh ? "ch" : "en"].buttonVideoUrl,
                "_blank"
              );
            }}
          >
            <ButtonIcon src={videoIcon} />
            {langCh ? "產品影片" : "Video"}
          </Button>
        )}
        {machineConfig[cardContent][langCh ? "ch" : "en"].moreInfo && (
          <Button
            onClick={(e) => {
              e.preventDefault();
              window.open(
                machineConfig[cardContent][langCh ? "ch" : "en"].moreInfo,
                "_blank"
              );
            }}
          >
            <ButtonIcon src={moreInfoIcon} />
            {langCh ? "更多資訊" : "Learn more"}
          </Button>
        )}
        {machineConfig[cardContent][langCh ? "ch" : "en"].onlineDemo && (
          <Button
            onClick={(e) => {
              e.preventDefault();
              window.open(
                machineConfig[cardContent][langCh ? "ch" : "en"].onlineDemo,
                "_blank"
              );
            }}
          >
            <ButtonIcon src={onlineDemoIcon} />
            {langCh ? "線上型錄" : "Brochure"}
          </Button>
        )}
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.open(
              langCh
                ? "https://www.ycmcnc.com/contact"
                : "https://www.ycmcnc.com/en/contact",
              "_blank"
            );
          }}
        >
          <ButtonIcon src={questionIcon} />
          {langCh ? "聯絡我們" : "Request a quote"}
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.open(
              langCh
                ? "https://www.ycmcnc.com/location"
                : "https://www.ycmcnc.com/en/location",
              "_blank"
            );
          }}
        >
          <ButtonIcon src={locationIcon} />
          {langCh ? "服務據點" : "Find your distributor"}
        </Button>
        {machineConfig[cardContent][langCh ? "ch" : "en"].automation && (
          <Button
            onClick={(e) => {
              e.preventDefault();
              window.open(
                machineConfig[cardContent][langCh ? "ch" : "en"].automation,
                "_blank"
              );
            }}
          >
            <ButtonIcon src={onlineDemoIcon} />
            {langCh ? "自動化解決方案" : "Automation"}
          </Button>
        )}
      </ButtonWrapper>
      <SpecificationTable>
        {machineConfig[cardContent][langCh ? "ch" : "en"].specification.map(
          (data, i) => (
            <tr key={i}>
              <td>
                <div style={{ margin: "0% 20%" }}>{data[0]}</div>
              </td>
              <td>
                <div style={{ margin: "0% 20%" }}>{data[1]}</div>
              </td>
            </tr>
          )
        )}
      </SpecificationTable>
      <Annotation>
        <p>{langCh ? annotationConfig.ch : annotationConfig.en}</p>
      </Annotation>
    </>
  );
};

export default MachineCard;
